import { LinearProgress } from "@mui/material";
import i18next from "i18next";
import useStyles from "style/js-style/components/common/ProcessPendingBlocStyle";

/**
 * Component with a progressbar used for process pending display
 * 
 * @param duration seconds | minutes
 */
const ProcessPendingBloc = ({duration = "seconds"}) => {
  const { classes } = useStyles();
  
  return (
    <div className={classes.pendingWrapper}>
      <LinearProgress className={classes.pendingLoadingBar} />
      <div className={classes.pendingTitle}>{i18next.t(`process.pending.title-${duration}`)}</div>
      <div className={classes.pendingSubTitle} >{i18next.t("process.pending.subtitle")}</div>
    </div>
  )
}
export default ProcessPendingBloc;